export type CadastroPromocaoFidelidadeModel = {
    possuiDelivery: boolean
    // PromocaoFidelidade
    premio: string
    tipoPontuacao: number
    valorPorSelo: string
    tipoPremio: number
    valorPremio: string
    valorPremioPercentual: string
    valorPremioPercentualMedia: string
    consumoMinimo: string
    quantidadeNecessaria: string
    valorConsumoMinimoParaSelo: string
    observacao: string
    exibirPublicamente: boolean
    naoPermitirFidelidadeRetiradaLocal: boolean
    regulamentoTexto: string
    // ParametroEstabelecimento
    bonificarIndicacaoAmigos: boolean
    bonificarPesquisaSatisfacao: boolean
    ignorarPedioMinimoNoResgate: boolean
    // Configurações avançadas
    fatorMultiplicadorSelos: string
    diasValidadeCartela: string
    diasRenovacao: string
    maximoRegistroSelosImpressosDiarios: string
    maximoRegistroSelosVirtuaisDiarios: string
    permiteResgateAnonimo: boolean
    validarMaximoDiarioDelivery: boolean
    freteGratisCartelaCompleta: boolean
    acumularSaldoRestante: boolean
}

function derivarTipoPontuacao(params: {
    valorPorSelo: string | null
    pontuarNoDelivery: boolean
    pontuarPorProduto: boolean
}): number {
    if (params.pontuarPorProduto) return 3
    if (!params.pontuarNoDelivery) return 2
    if (params.valorPorSelo !== null && params.valorPorSelo !== undefined) return 0
    return 1
}

function derivarTipoPremio(params: {
    valorPremio: string | null
    valorPremioPercentualMedia: string | null
    valorPremioPercentual: string | null
}): number {
    if (params.valorPremio !== null && params.valorPremio !== undefined) return 0
    if (params.valorPremioPercentualMedia !== null && params.valorPremioPercentualMedia !== undefined) return 1
    if (params.valorPremioPercentual !== null && params.valorPremioPercentual !== undefined) return 2
    return -1
}

export function modeloDoBackend(dados: {
    possuiDelivery?: boolean
    premio?: string | null
    valorPorSelo?: string | null
    valorPremio?: string | null
    valorPremioPercentual?: string | null
    valorPremioPercentualMedia?: string | null
    valorConsumoMinimoParaSelo?: string | null
    consumoMinimo?: string | null
    quantidadeNecessaria?: number | null
    observacao?: string | null
    exibirPublicamente?: boolean
    naoPermitirFidelidadeRetiradaLocal?: boolean
    regulamentoTexto?: string | null
    bonificarIndicacaoAmigos?: boolean
    bonificarPesquisaSatisfacao?: boolean
    ignorarPedioMinimoNoResgate?: boolean
    fatorMultiplicadorSelos?: number | null
    diasValidadeCartela?: number | null
    diasRenovacao?: number | null
    maximoRegistroSelosImpressosDiarios?: number | null
    maximoRegistroSelosVirtuaisDiarios?: number | null
    permiteResgateAnonimo?: boolean
    validarMaximoDiarioDelivery?: boolean
    freteGratisCartelaCompleta?: boolean
    acumularSaldoRestante?: boolean
    pontuarNoDelivery?: boolean
    pontuarPorProduto?: boolean
}): CadastroPromocaoFidelidadeModel {
    return {
        possuiDelivery: dados.possuiDelivery ?? false,
        premio: dados.premio ?? "",
        tipoPontuacao: derivarTipoPontuacao({
            valorPorSelo: dados.valorPorSelo ?? null,
            pontuarNoDelivery: dados.pontuarNoDelivery ?? true,
            pontuarPorProduto: dados.pontuarPorProduto ?? false,
        }),
        valorPorSelo: dados.valorPorSelo ?? "",
        tipoPremio: derivarTipoPremio({
            valorPremio: dados.valorPremio ?? null,
            valorPremioPercentualMedia: dados.valorPremioPercentualMedia ?? null,
            valorPremioPercentual: dados.valorPremioPercentual ?? null,
        }),
        valorPremio: dados.valorPremio ?? "",
        valorPremioPercentual: dados.valorPremioPercentual ?? "",
        valorPremioPercentualMedia: dados.valorPremioPercentualMedia ?? "",
        valorConsumoMinimoParaSelo: dados.valorConsumoMinimoParaSelo ?? "",
        consumoMinimo: dados.consumoMinimo ?? "",
        quantidadeNecessaria: dados.quantidadeNecessaria != null ? String(dados.quantidadeNecessaria) : "",
        observacao: dados.observacao ?? "",
        exibirPublicamente: dados.exibirPublicamente ?? true,
        naoPermitirFidelidadeRetiradaLocal: dados.naoPermitirFidelidadeRetiradaLocal ?? false,
        regulamentoTexto: dados.regulamentoTexto ?? "",
        bonificarIndicacaoAmigos: dados.bonificarIndicacaoAmigos ?? true,
        bonificarPesquisaSatisfacao: dados.bonificarPesquisaSatisfacao ?? true,
        ignorarPedioMinimoNoResgate: dados.ignorarPedioMinimoNoResgate ?? true,
        fatorMultiplicadorSelos: dados.fatorMultiplicadorSelos != null ? String(dados.fatorMultiplicadorSelos) : "1",
        diasValidadeCartela: dados.diasValidadeCartela != null ? String(dados.diasValidadeCartela) : "120",
        diasRenovacao: dados.diasRenovacao != null ? String(dados.diasRenovacao) : "30",
        maximoRegistroSelosImpressosDiarios: dados.maximoRegistroSelosImpressosDiarios != null ? String(dados.maximoRegistroSelosImpressosDiarios) : "10",
        maximoRegistroSelosVirtuaisDiarios: dados.maximoRegistroSelosVirtuaisDiarios != null ? String(dados.maximoRegistroSelosVirtuaisDiarios) : "5",
        permiteResgateAnonimo: dados.permiteResgateAnonimo ?? false,
        validarMaximoDiarioDelivery: dados.validarMaximoDiarioDelivery ?? false,
        freteGratisCartelaCompleta: dados.freteGratisCartelaCompleta ?? false,
        acumularSaldoRestante: dados.acumularSaldoRestante ?? false,
    }
}

export const CadastroPromocaoFidelidadeInicial: CadastroPromocaoFidelidadeModel = {
    possuiDelivery: false,
    premio: "",
    tipoPontuacao: 1,
    valorPorSelo: "",
    tipoPremio: -1,
    valorPremio: "",
    valorPremioPercentual: "",
    valorPremioPercentualMedia: "",
    valorConsumoMinimoParaSelo: "",
    consumoMinimo: "",
    quantidadeNecessaria: "",
    observacao: "",
    exibirPublicamente: true,
    naoPermitirFidelidadeRetiradaLocal: false,
    regulamentoTexto: "",
    bonificarIndicacaoAmigos: true,
    bonificarPesquisaSatisfacao: true,
    ignorarPedioMinimoNoResgate: true,
    fatorMultiplicadorSelos: "1",
    diasValidadeCartela: "120",
    diasRenovacao: "30",
    maximoRegistroSelosImpressosDiarios: "10",
    maximoRegistroSelosVirtuaisDiarios: "5",
    permiteResgateAnonimo: false,
    validarMaximoDiarioDelivery: false,
    freteGratisCartelaCompleta: false,
    acumularSaldoRestante: false,
}
